export const SIGNATURE_COMPONENT_DEFAULT_HEIGHT = 34;
export const SIGNATURE_COMPONENT_DEFAULT_WIDTH = 134;
export const SIGNATURE_COMPONENT_MINIMUM_WIDTH = 36;
export const DEFAULT_TEXT_SIGNATURE_LABEL = 'Text';
export const CONTRACT_COMPONENT_DEFAULT_HEIGHT = 22;
export const CONTRACT_COMPONENT_DEFAULT_WIDTH = 134;
export const CONTRACT_COMPONENT_MINIMUM_WIDTH = 24;
// A checkbox with no label is just the box (ml-2 + h-4/w-4 + a little breathing
// room), so its tile shrinks to this instead of the full default width.
export const CONTRACT_CHECKBOX_NO_LABEL_WIDTH = 32;
// Checkbox labels are short captions (the tile truncates them anyway), so cap the
// input well below the 4000-char limit used for free-form text fields. Kept in sync
// with the backend's CheckboxLabelMaxLength safety net.
export const CONTRACT_CHECKBOX_LABEL_MAX_LENGTH = 200;
